import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-privacy',
  templateUrl: './show-privacy.component.html',
  styleUrls: ['./show-privacy.component.scss'],
})
export class ShowPrivacyComponent implements OnInit {
  privacy: string;
  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    const admin = await this.db.toDoc$(`admin/terms`);
    this.privacy = admin.personal;
  }
}
